import Cardimage from '../../assets/Card-image.svg';
export function Stats() {
  const stats = [
    {
      value: '40M+',
      label: 'Compromised Devices Monitored',
    },
    {
      value: '8B+',
      label: 'Stolen Credentials Detected',
    },
    {
      value: '50+',
      label: 'Enterprise Clients Protected',
    },
  ];

  return (
    <section className="px-6 pb-24">
      <div className="container mx-auto max-w-6xl">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="relative p-8 rounded-2xl bg-gradient-to-br from-emerald-950/20 to-transparent transition-all group backdrop-blur-sm"
            >
              <img src={Cardimage} className='absolute top-0 left-0 w-full' width={100} height={100} />
              <div className="absolute inset-0 bg-emerald-500/5 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity" />
              <div className="relative text-center">
                <div className="text-2xl font-bold text-emerald-400 mb-2 tracking-tight">{stat.value}</div>
                <div className="text-white text-md leading-relaxed">{stat.label}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
